<template>
  <div v-if="$site.location" class="bg-secondary flex flex-col">
    <div id="main" class="relative flex-grow flex-shrink">
      <slot />
    </div>
    <client-only>
      <LayoutElementsCookie v-if="$site.settings.showCookieConsent" layout="site" />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import Utils from '@/utils'

const router = useRouter()
const route = useRoute()

const layoutStore = useLayoutStore()

const { $site } = useNuxtApp()

useHead(() => {
  return {
    htmlAttrs: {
      class: 'layout-widget'
    }
  }
})

const listeners = ref({
  resize: null
})

// Set the home route for the widget
layoutStore.homeRoute = { path: route.path };

onMounted(() => {
  try {
    router.afterEach((to, from) => {
      if (Utils.browser.inIframe() && window.parent) {
        window.postRobot?.send(window.parent, 'bookapp.event.url-changed', to.fullPath)

        if (to && from && to.path !== from.path) {
          window.postRobot?.send(window.parent, 'bookapp.event.page-changed', to.fullPath)
        }
      }
    })

    if ($site.isEmbed && window.parent) {
      window.postRobot?.send(window.parent, 'bookapp.widget.event.ready')

      // if (!this.listeners.resize) {
        listeners.value.resize = window.postRobot.on('bookapp.widget.resize', { window: window.parent }, () => {
          window.postRobot?.send(window.parent, 'bookapp.widget.event.resize', document.body.scrollHeight)
        })
      // }

      useResizeObserver(document.body, () => {
        window.postRobot?.send(window.parent, 'bookapp.widget.event.resize', document.body.scrollHeight)
      })

      window.postRobot?.send(window.parent, 'bookapp.widget.event.resize', document.body.scrollHeight)

      // const path = route.path
       // route.path
    } else {
      const query = { ...route.query }
      delete query.layout
      router.replace({ query })

      // layoutStore.setLayout('site')
    }
  } catch (e) {
    console.error(e)
  }
})
</script>

<style>
html.layout-widget #__layout {
  overflow-x: hidden;
}

html.layout-widget body {
  background-color: var(--bookapp-content-tint2-color) !important;
  display: flex;
  flex-flow: column;
  overflow: hidden;
}

html.layout-widget #content-wrapper {
  margin-bottom: 40px;
}
</style>
